import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api';
import { DEFAULT_SETTINGS } from '../config';

const SettingsContext = createContext({ settings: DEFAULT_SETTINGS, loading: true });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api
      .getSettings()
      .then((res) => {
        if (alive && res?.settings) setSettings({ ...DEFAULT_SETTINGS, ...res.settings });
      })
      .catch(() => {
        // Backend not ready — keep defaults so the store still works.
      })
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading }}>{children}</SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
